@use "~theme/breakpoints";

@mixin card {
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 10%);
  background-color: var(--white);
  opacity: 1;
  gap: 20px;
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}

.card {
  @include card;
}

.desktopOnly {
  border-radius: 0;
  box-shadow: none;

  @include breakpoints.desktop {
    @include card;
  }
}